import { endOfDay, startOfDay, subMonths } from 'date-fns';

type DateFilterQuery = {
  from?: Date | null;
  to?: Date | null;
};

export function applyDefaultThreeMonthFilter<T extends DateFilterQuery>(
  query: T,
): T {
  // Only apply default 3-month filter if both from and to are empty
  if (!query.from && !query.to) {
    const now = new Date();
    const threeMonthsAgo = startOfDay(subMonths(now, 3));
    const today = endOfDay(now);

    return {
      ...query,
      from: threeMonthsAgo,
      to: today,
    };
  }

  return query;
}
